<template>
  <div class="app-container">
    <CrudTable
      entity="FabricOrder"
      :columns="columns"
      :allow-create="false"
      :allow-delete="false"
      :generate-summary="generateSummary"
    />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';

export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        {
          field: 'domainName',
          label: 'fabricOrder.domainName',
          filter: {
            type: 'select',
            options: this.$store.getters.domains,
            valueField: 'id',
            labelField: 'name',
            filterName: 'domainID'
          }
        },
        { field: 'orderNumber', label: 'fabricOrder.orderNumber' },
        { field: 'createdAt', label: 'fabricOrder.createdAt', type: 'date', filter: { type: 'date' } },
        {
          field: 'externallyModifiedAt',
          label: 'fabricOrder.externallyModifiedAt',
          type: 'dateTime',
          filter: { type: 'date' }
        },
        { field: 'supplierCode', label: 'fabricOrder.supplierCode' },
        { field: 'supplierName', label: 'fabricOrder.supplierName' },
        {
          field: 'totalQuantityOrderedInMeters',
          label: 'fabricOrder.totalQuantityOrderedInMeters',
          sortable: false,
          filter: { type: 'none' }
        },
        {
          field: 'totalQuantityDeliveredInMeters',
          label: 'fabricOrder.totalQuantityDeliveredInMeters',
          sortable: false,
          filter: { type: 'none' }
        },
        {
          field: 'estimatedDepartureAt',
          label: 'fabricOrder.estimatedDepartureAt',
          type: 'date',
          filter: { type: 'date' }
        },
        {
          field: 'estimatedDeliveryAt',
          label: 'fabricOrder.estimatedDeliveryAt',
          type: 'date',
          filter: { type: 'date' }
        },
        { field: 'actualDeliveryAt', label: 'fabricOrder.actualDeliveryAt', type: 'date', filter: { type: 'date' } },
        {
          field: 'fabricOrderStatusOption',
          label: 'fabricOrder.fabricOrderStatusOption',
          formatter: this.fabricOrderStatus,
          filter: {
            type: 'select',
            options: this.$store.getters['option/loadedOptions']('fabricOrderStatus'),
            valueField: 'code',
            labelField: 'description'
          }
        }
      ]
    };
  },
  methods: {
    getColumn(fieldName) {
      return this.columns.find(c => c.field === fieldName);
    },
    generateSummary({ domainName, plannedDeliveryAt }) {
      return `${domainName} ${plannedDeliveryAt}`;
    },
    fabricOrderStatus(row, column, cellValue) {
      const option =
        cellValue !== null &&
        this.$store.getters['option/loadedOptions']('fabricOrderStatus').find(item => item.code === cellValue);
      return option && option.description;
    }
  }
};
</script>
